import React, { useState } from "react";
import { Text, View } from "react-native-web";
import { Rate } from "antd";
import "./Chart.css";

const Chart = (props) => {
	return (
		<div>
			<Graph
				currentPoll={props.currentPoll}
				votesPerOption={props.votesPerOption}
				totalVotes={props.totalVotes}
				graphTitle="Top 6 Cryptocurrencies by Market Capitalization(%)"
			/>
		</div>
	);
};

class Graph extends React.Component {
	state = {};

	renderLines() {
		return Array(11)
			.fill(null)
			.map((el, i) => <Line left={i * 10} key={i} />);
	}

	renderBars() {
		const { currentPoll, votesPerOption, totalVotes } = this.props;

		if (currentPoll.isRating) {
			return [...Array(5)].map((currency, i) => {
				const percent = (votesPerOption[i] / totalVotes) * 100;
				return (
					<Bar
						percent={percent}
						name={i + 1}
						showStar
						starCount={i + 1}
						value={votesPerOption[i]}
						color={"gold"}
					/>
				);
			});
		}

		return currentPoll.options.map((currency, i) => {
			const percent = (votesPerOption[i] / totalVotes) * 100;
			return (
				<Bar
					percent={percent}
					name={currentPoll.options[i]}
					value={votesPerOption[i]}
					color={currentPoll.colors[i]}
				/>
			);
		});
	}

	render() {
		const { currentPoll, totalVotes } = this.props;
		return (
			<div className="graph-wrapper">
				<View
					style={{
						justifyContent: "center",
						alignContent: "center",
						marginBottom: 20,
					}}
				>
					<Text
						style={{
							fontFamily: "NunitoSans",
							textAlign: "center",
							marginTop: 20,
							fontSize: 20,
							fontWeight: "600",
							alignSelf: "center",
							marginHorizontal: 5,
						}}
					>
						{currentPoll.question}
					</Text>
					<Text
						style={{
							marginLeft: 5,
							textAlign: "center",
							marginVertical: 10,
						}}
					>
						{totalVotes}
						{" Votes"}
					</Text>
				</View>

				<View style={{ marginHorizontal: 20 }}>
					<View>
						{this.renderLines()}
						{this.renderBars(currentPoll)}
					</View>

					{/* <div style={{ width: "12%" }} />*/}
					{/* <Markers /> */}
				</View>
			</div>
		);
	}
}

const Markers = () => {
	const markerArr = Array(11).fill(null);

	return (
		<div className="markers">
			{markerArr.map((el, i) => (
				<span className="marker" style={{ left: `${i * 10}%` }}>
					{i * 10}
				</span>
			))}
		</div>
	);
};

const Bar = ({ percent, value, name, color, showStar, starCount }) => {
	// return (
	//   <div className="bar" style={{ width: `${percent}%` }} />
	// )
	return (
		<View>
			{showStar ? (
				<View
					style={{
						marginTop: 20,
						fontSize: 15,
					}}
				>
					<Rate
						disabled
						style={{ fontSize: 20 }}
						defaultValue={starCount}
						value={starCount}
					/>
				</View>
			) : (
				<Text
					style={{
						marginTop: 20,
						marginLeft: 5,
						fontSize: 15,
						fontWeight: "500",
					}}
				>
					{name}
				</Text>
			)}

			<View
				style={{ flexDirection: "row", marginTop: 10, alignItems: "center" }}
			>
				<div
					className="bar"
					style={{ width: `${percent}%`, height: 30, backgroundColor: color }}
				/>
				<Text style={{ marginLeft: 10, fontSize: 15, fontWeight: "500" }}>
					{value}
				</Text>
			</View>
		</View>
	);
};

const BarTextContent = ({ currencies }) => {
	return (
		<div className="bar-text-content">
			{currencies.map((currency) => (
				<div className="text">{currency.currencyName}</div>
			))}
		</div>
	);
};

const Line = ({ left }) => {
	return <div className="line" style={{ left: `${left}%` }} />;
};

export default Chart;
